export const QuestionTypeEnum = {
    INPUT: 'input',
    SELECT: 'select',
    STYLE: 'style',
} as const;

export type QuestionType =
    (typeof QuestionTypeEnum)[keyof typeof QuestionTypeEnum];
